(() => {
  'use strict';

  const KLAVIYO_ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/';
  const KLAVIYO_REVISION = '2024-10-15';
  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const init = (container) => {
    if (container.dataset.gameSignupBound === 'true') return;
    container.dataset.gameSignupBound = 'true';

    const form = container.querySelector('.game-signup__form');
    if (!form) return;

    const emailInput = form.querySelector('.game-signup__email');
    const honeypot = form.querySelector('input[name="company"]');
    const submitBtn = form.querySelector('.game-signup__submit');
    const status = form.querySelector('.game-signup__status');

    const { klaviyoCompany: companyId, klaviyoList: listId, gameHandle, gameLabel, locale } = container.dataset;
    const successMsg = container.dataset.success || 'Thanks!';
    const errorMsg = container.dataset.error || 'Something went wrong. Please try again.';
    const sendingMsg = container.dataset.sending || 'Sending…';

    const setStatus = (message, type) => {
      status.textContent = message;
      status.className = 'game-signup__status' + (type ? ' is-' + type : '');
    };

    const showSuccess = () => {
      form.querySelector('.game-signup__fields').hidden = true;
      setStatus(successMsg, 'success');
    };

    form.addEventListener('submit', (event) => {
      event.preventDefault();

      if (honeypot && honeypot.value.trim() !== '') {
        showSuccess();
        return;
      }

      const email = (emailInput.value || '').trim();
      if (!EMAIL_RE.test(email)) {
        setStatus(emailInput.validationMessage || 'Please enter a valid email.', 'error');
        emailInput.focus();
        return;
      }

      if (!companyId || !listId) {
        setStatus(errorMsg, 'error');
        return;
      }

      submitBtn.disabled = true;
      setStatus(sendingMsg, 'pending');

      const properties = { last_game_label: gameLabel };
      if (gameHandle) {
        properties['interest_' + gameHandle] = true;
      }
      if (locale) {
        properties.signup_language = locale;
      }

      const payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: gameHandle,
            profile: {
              data: {
                type: 'profile',
                attributes: { email, properties }
              }
            }
          },
          relationships: {
            list: {
              data: { type: 'list', id: listId }
            }
          }
        }
      };

      fetch(KLAVIYO_ENDPOINT + '?company_id=' + encodeURIComponent(companyId), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          revision: KLAVIYO_REVISION
        },
        body: JSON.stringify(payload)
      })
        .then((response) => {
          if (response.ok) {
            showSuccess();
          } else {
            setStatus(errorMsg, 'error');
            submitBtn.disabled = false;
          }
        })
        .catch(() => {
          setStatus(errorMsg, 'error');
          submitBtn.disabled = false;
        });
    });
  };

  const initAll = () => document.querySelectorAll('.game-signup').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
